import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FeatherIconNames} from 'feather-icons';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';

@Component({
  selector: 'app-alert',
  imports: [CommonModule, FeatherPipe],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {
  @Input() type: 'success' | 'danger' | 'warning' | 'info' = 'info';
  @Input() icon?: FeatherIconNames | null = null;
  @Input() iconSize: number = 16;
}
